import { Button } from "@flexisaf/flexibull2";
import Theme from "../../theme";
import styled, { css } from "styled-components";

const FileWrapper = styled.div`
  /* padding: 15px; */
  width: 100%;
  display: block;
  text-align: center;
  border-radius: ${Theme.SecondaryRadius};
  border: 1px dashed ${Theme.PrimaryGrey};
  ${(props) =>
    props.noBorder &&
    css`
      border: none;
    `}
  /* margin-bottom: 20px; */

  & .inputfile {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;

    & + label {
      max-width: 80%;
      font-size: 0.8rem;
      font-weight: 400;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;
      display: inline-block;
      overflow: hidden;
      padding: 0.625rem 1.25rem;
      outline: transparent;

      & figure {
        width: 100px;
        height: 100px;
        border: 1px dashed ${Theme.PrimaryGrey};
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        padding: 20px;
        margin: 0 auto 20px;

        &::after,
        ::before {
          width: 0;
          height: 0;
          content: "";
          position: absolute;
          top: 0;
          right: 0;
        }

        & svg {
          width: 2em;
          height: 2em;
          vertical-align: middle;
          fill: ${Theme.PrimaryGrey};
          margin-top: -0.25em;
          margin-right: 0.25em;
        }
      }

      & p {
        font-weight: 600;
        font-size: 14px;
      }
    }

    &:focus {
      & + label {
        outline: 1px dotted #000;
        outline: -webkit-focus-ring-color auto 5px;
      }
    }
  }
`;

export const FileUploader = (props) => {
  return (
    <FileWrapper {...props}>
      <input
        type="file"
        onChange={props.onChange}
        accept={props.accept}
        name={props.name}
        id={`file-${props.name}`}
        className="inputfile"
        data-multiple-caption="files selected"
        multiple={props.multiple ?? false}
      />
      <label for={`file-${props.name}`}>
        {/* <figure>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="17"
            viewBox="0 0 20 17"
          >
            <path d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z" />
          </svg>
        </figure> */}
        {/* <p>Drag and Drop files here</p> */}
        <span>{props.label}</span>
        <Button block style={{ margin: "10px 0" }}>
          {props.title || `Browse file`}
        </Button>
        <small>{props.size}</small>
      </label>
    </FileWrapper>
  );
};
